import React from 'react';
import styled, { css } from 'styled-components';
import { sectionMargins, sectionPaddings, standardColours } from '../styles';
import CardSlider from './CardSlider';
import ProductCategoryCard from './ProductCategoryCard';

const StyledFeaturedProductCategories = styled.section`
  ${({ alt }) => {
    if (alt) {
      return css`
        ${sectionMargins()};
      `;
    } else {
      return css`
        ${sectionPaddings()};
        background-color: ${standardColours.lightestGrey};
      `;
    }
  }}
`;

const StyledItem = styled(ProductCategoryCard)`
  height: 100%;
`;

const FeaturedProductCategories = ({ heading, items, alt, ...props }) => (
  <StyledFeaturedProductCategories alt={alt} {...props}>
    <CardSlider heading={heading}>
      {items.map((item, id) => (
        <StyledItem key={id} {...item} />
      ))}
    </CardSlider>
  </StyledFeaturedProductCategories>
);

export default FeaturedProductCategories;
